var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDouglasIconsLogoRgb1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 47,
    height: 31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.35939 6.94116H50.6287V36.6448H4.35939V6.94116Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8002 32.2615C22.0478 32.5959 21.2595 32.8467 20.3757 33.0139C19.0022 33.3006 17.4973 33.3842 15.8252 33.3842H7.20195V10.154H15.8371C17.5092 10.154 19.0022 10.2376 20.3876 10.5242C25.8578 11.6947 28.8556 15.6599 28.8556 21.787C28.8556 24.0443 28.4376 26.0031 27.6851 27.6274C28.1868 28.4634 28.8556 29.1681 29.5603 29.8011C30.9338 27.5438 31.6862 24.7968 31.6862 21.787C31.6862 14.3581 27.7687 9.43736 21.0923 7.98025C19.5874 7.64583 18.0109 7.5264 16.2552 7.5264H4.35939V36.0595H16.2432C17.9989 36.0595 19.5755 35.9759 21.0803 35.6415C22.3702 35.3548 23.5885 34.9368 24.6634 34.3516C23.9707 33.8022 23.3018 33.0139 22.8002 32.2615ZM35.9501 6.94116C33.0239 6.94116 30.3605 7.77721 28.1509 9.19849C28.8556 9.73595 29.5244 10.4048 30.0738 11.0736C31.7818 10.1181 33.7883 9.61652 35.9501 9.61652C42.8773 9.61652 47.798 14.7045 47.798 21.7989C47.798 28.8456 42.8773 33.8977 35.9501 33.8977C29.1064 33.8977 24.1857 28.8456 24.1857 21.7989C24.1857 19.6252 24.6395 17.6665 25.4756 15.9585C24.9739 15.1703 24.3529 14.5014 23.5527 13.9162C22.1314 16.2093 21.3431 18.9205 21.3431 21.7989C21.3431 30.3983 27.4701 36.6567 35.9501 36.6567C44.3344 36.6567 50.6406 30.2788 50.6406 21.7989C50.6406 13.319 44.3344 6.94116 35.9501 6.94116Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 40,
    width: 7,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0814 40.4558H24.1249V48.5177H18.0814V40.4558Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3366 45.2929C23.3366 45.6512 23.2888 45.9857 23.2052 46.2723C22.9305 47.2278 22.1422 47.7533 21.0912 47.7533C20.0521 47.7533 19.2638 47.2278 18.9891 46.2723C18.9055 45.9857 18.8578 45.6512 18.8578 45.2929V40.4558H18.0695V45.3646C18.0695 45.7707 18.1411 46.2723 18.2486 46.5948C18.6308 47.8011 19.6222 48.5177 21.1031 48.5177C22.5841 48.5177 23.5635 47.7772 23.9577 46.5709C24.0651 46.2484 24.1249 45.7468 24.1249 45.3407V40.4558H23.3366V45.2929Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 40,
    width: 6,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7448 40.2886H49.4984V48.5177H44.7448V40.2886Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8263 44.1105L46.9902 43.7044C46.2856 43.3581 45.8795 42.9401 45.8795 42.2832C45.8795 41.5427 46.3931 41.0171 47.1813 41.0171C48.0054 41.0171 48.4593 41.5904 48.5907 42.5101H49.3312C49.1878 40.9813 48.304 40.3005 47.1813 40.3005C45.9392 40.3005 45.0912 41.1963 45.0912 42.319C45.0912 43.3461 45.7123 44.003 46.7036 44.4569L47.5516 44.851C48.1607 45.1377 48.6982 45.5796 48.6982 46.3917C48.6982 47.2039 48.1249 47.7533 47.2649 47.7533C46.3453 47.7533 45.6645 47.2278 45.5331 45.9618H44.7448C44.8762 47.7055 45.8675 48.5177 47.253 48.5177C48.6026 48.5177 49.5103 47.61 49.5103 46.3559C49.4984 45.0899 48.6862 44.5286 47.8263 44.1105Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.7872 40.4526L37.7296 48.3473H38.6135L39.5451 45.8392H42.8057L43.7492 48.3473H44.645L41.5755 40.4526H40.7872ZM42.519 45.0987H39.8198L40.7275 42.6861C40.8947 42.2561 41.0261 41.8261 41.1694 41.4081C41.3127 41.8381 41.456 42.2681 41.6232 42.6861L42.519 45.0987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6004 40.4526H33.8122V48.3473H36.9772L37.2877 47.6068H34.6004V40.4526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 40,
    width: 8,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0358 40.2886H32.8947V48.5177H25.0358V40.2886Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2845 44.7196V45.4601H32.0228C31.7362 46.8336 30.5896 47.7533 29.0727 47.7533C27.1498 47.7533 25.8241 46.3559 25.8241 44.3972C25.8241 42.4384 27.1737 41.0291 29.0727 41.0291C30.3388 41.0291 31.3898 41.686 31.8436 42.8206H32.6916C32.202 41.256 30.7807 40.2886 29.0727 40.2886C26.7557 40.2886 25.0358 42.0562 25.0358 44.3972C25.0358 46.7978 26.696 48.5177 29.0727 48.5177C31.3181 48.5177 32.9186 46.8934 32.8947 44.7316H28.2845V44.7196Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 40,
    width: 9,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.06622 40.2769H17.1878V48.5179H9.06622V40.2769Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1151 40.2769C12.3388 40.2769 11.6221 40.4799 11.025 40.8382C11.228 41.0054 11.4072 41.1846 11.5744 41.3757C12.0282 41.1487 12.5418 41.0174 13.1151 41.0174C15.038 41.0174 16.3996 42.4267 16.3996 44.3974C16.3996 46.3561 15.038 47.7535 13.1151 47.7535C11.2161 47.7535 9.8545 46.3561 9.8545 44.3974C9.8545 43.836 9.96199 43.3225 10.165 42.8805C10.0217 42.6417 9.86644 42.4745 9.63951 42.3073C9.26926 42.9403 9.06622 43.6091 9.06622 44.3974C9.06622 46.7741 10.7622 48.5179 13.1151 48.5179C15.4441 48.5179 17.1878 46.7503 17.1878 44.3974C17.1878 42.0564 15.4321 40.2769 13.1151 40.2769Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 40,
    width: 8,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.35939 40.4438H11.9316V48.3505H4.35939V40.4438Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76981 47.7891C9.62649 47.6458 9.50706 47.5025 9.38762 47.3353C9.20847 47.4069 9.01737 47.4666 8.80239 47.5025C8.42019 47.5861 8.00217 47.61 7.54832 47.61H5.15961V41.1724H7.54832C8.00217 41.1724 8.43214 41.1963 8.80239 41.2799C10.3192 41.6024 11.1433 42.7012 11.1433 44.3972C11.1433 44.9824 11.0478 45.484 10.8686 45.914C11.0119 46.1648 11.1792 46.3559 11.3941 46.5351C11.7405 45.9379 11.9316 45.2452 11.9316 44.3972C11.9316 42.3429 10.8447 40.9813 8.99348 40.5752C8.57546 40.4797 8.13355 40.4438 7.65581 40.4438H4.35939V48.3505H7.65581C8.13355 48.3505 8.57546 48.3266 8.99348 48.231C9.3279 48.1594 9.62649 48.0638 9.91314 47.9324C9.86536 47.8847 9.81759 47.8369 9.76981 47.7891Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouglasIconsLogoRgb1);
export default __webpack_public_path__ + "static/media/Douglas_Icons_Logo_rgb_1.f4f626c7.svg";
export { ForwardRef as ReactComponent };